export default {
	name: 'config-manage',
	path: '/config-manage',
	component: () => import('@/static-page/keep-alive.vue'),
	// redirect: GetRedirect,
	meta: {
		showSiderMenu: true // layout布局是否显示左侧菜单
	},

	children: [

		/* -------------------- 摄像头管理 -------------------- */
		{
			name: 'config-manage-cameras-table',
			path: '/config-manage/cameras/table',
			component: () => import('./pages/cameras/cameras-table.vue'),
			meta: { menuKey: '/config-manage/cameras/table', keepAlive: true }
		},
		{
			name: 'config-manage-cameras-form-add',
			path: '/config-manage/cameras/add',
			component: () => import('./pages/cameras/cameras-form.vue'),
			meta: { LayoutNoSideMenu: true, menuKey: '/config-manage/cameras/table' }
		},
		{
			name: 'config-manage-cameras-form-update',
			path: '/config-manage/cameras/update',
			component: () => import('./pages/cameras/cameras-form.vue'),
			meta: { LayoutNoSideMenu: true, menuKey: '/config-manage/cameras/table' }
		},
		{
			name: 'config-manage-cameras-algorithm',
			path: '/config-manage/cameras/algorithm',
			component: () => import('./pages/cameras/cameras-algorithm.vue'),
			meta: { LayoutNoSideMenu: true, menuKey: '/config-manage/cameras/table' }
		},



		/* -------------------- AI算法管理 -------------------- */
		{
			name: 'ai-algorithm-manage',
			path: '/config-manage/ai-algorithm-manage',
			component: () => import('./pages/ai-algorithm/index.vue'),
			meta: { menuKey: '/config-manage/ai-algorithm-manage' }
		},

		

		/* -------------------- 报警设置 -------------------- */
		{
			name: 'alarm-setting',
			path: '/config-manage/alarm-setting',
			component: () => import('./pages/alarm-setting/alarm-setting.vue'),
			meta: { menuKey: '/config-manage/alarm-setting',noPermission: true }
		},

		/* -------------------- 系统管理 -------------------- */
		{
			name: 'config-manage-system-manage',
			path: '/config-manage/system-manage',
			component: () => import('./pages/system-manage/index.vue'),
			meta: {
				LayoutNoSideMenu: false,
				menuKey: '/config-manage/system-manage'
			},
			children: [
				/* -------------------- 账号管理 -------------------- */
				{
					name: 'system-accounts-table',
					path: '/config-manage/system/accounts/table',
					component: () => import('./pages/system-manage/accounts/accounts-table.vue'),
					meta: { menuKey: '/config-manage/system-manage' }
				},
				/* -------------------- 角色管理 -------------------- */
				{
					name: 'system-roles-table',
					path: '/config-manage/system/roles/table',
					component: () => import('./pages/system-manage/roles/roles-table.vue'),
					meta: { menuKey: '/config-manage/system-manage' }
				},
				{
					name: 'system-roles-form-add',
					path: '/config-manage/system/roles/add',
					component: () => import('./pages/system-manage/roles/roles-form.vue'),
					meta: {
						LayoutNoSideMenu: true,
						menuKey: '/config-manage/system-manage'
					}
				},
				{
					name: 'system-roles-form-update',
					path: '/config-manage/system/roles/update',
					component: () => import('./pages/system-manage/roles/roles-form.vue'),
					meta: {
						LayoutNoSideMenu: true,
						menuKey: '/config-manage/system-manage'
					}
				},
				{
					name: 'system-role-members-table',
					path: '/config-manage/system/roles/members-table',
					component: () => import('./pages/system-manage/roles/role-members-table.vue'),
					meta: {
						LayoutNoSideMenu: true,
						menuKey: '/config-manage/system-manage'
					}
				},
				/* -------------------- 操作日志 -------------------- */
				{
					name: 'system-logs-table',
					path: '/config-manage/system/system-logs/table',
					component: () => import('./pages/system-manage/system-logs/system-logs-table.vue'),
					meta: { menuKey: '/config-manage/system-manage' }
				},
                 /* -------------------- 企业信息配置 -------------------- */
				{
					name: 'system-company-form',
					path: '/config-manage/system/company/form',
					component: () => import('./pages/system-manage/company/company-form.vue'),
					meta: { menuKey: '/config-manage/system-manage' }
				},
				/* -------------------- VL大模型 -------------------- */
				{
					name: 'system-large-model',
					path: '/config-manage/system/large-model',
					component: () => import('./pages/system-manage/large-mode/index.vue'),
					meta: { menuKey: '/config-manage/system/large-model', noPermission: true }
				}
			]
		},

	]
};
